import React, {Component} from 'react';
import moment from 'moment';

class ChangelogItem extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {change} = this.props;
        return (
            <div className="row changelog-row" key={change.timestamp}>
                { change.description }

                <i className="fa fa-pencil-square-o changelog-icon" aria-hidden="true" />
                <span className="changelog-date">
                    { moment.unix(change.timestamp).format('DD, MMMM Y') }
                </span>
                <span>
                    by <strong>{ change.user.name }</strong>
                    {' '}
                    {'<'}{ change.user.email }{'>'}
                </span>
            </div>
        );
    }
}

export default ChangelogItem;


// WEBPACK FOOTER //
// ./web/src/components/dashboard/ChangelogItem.jsx